import { useCallback, useContext } from "react";
import { ModalsWrapperContext } from "@kanda-libs/ks-component-ts";
import { MODAL_ID } from "components/job/JobRevertModal/constants";

export interface JobRevertButtonPropsHook {
  onClick: () => void;
}

export default function useJobRevertButtonProps(): JobRevertButtonPropsHook {
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(() => {
    showModal(MODAL_ID);
  }, [showModal]);

  return {
    onClick,
  };
}
